import { urlApiTegra, get, postFormData } from "../../../service/api";

export const getInvoicesUser = ({
  token,
}: {
  token: string;
}): Promise<{ month: number; paymentAmount: number; timeApproved: string; urlStatement: string; year: number }[]> => {
  return get(`${urlApiTegra}/pdf-invoice`, token);
};

export const uploadInvoice = ({ token, file, year, month }: { token: string; file: any; year: string; month: string }) => {
  const body = JSON.stringify({
    year,
    month,
  });

  return postFormData(`${urlApiTegra}/pdf-invoice`, { file, body }, token);
};
